import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import { useLabels } from '@core-front/label-provider';
const PassFieldCore = (props) => {
    const labels = useLabels();
    return (React.createElement(AnalyticsTrigger, { trigger: {
            callback: 'onToggle',
            id: `Field - Passfield - Show/Hide - ${props.id}`,
            elementId: `${props.id}`,
            elementType: 'field',
            interactionType: 'toggle',
        } },
        React.createElement(PassFieldCoreInner, Object.assign({}, props, { labels: labels }))));
};
export default PassFieldCore;
class PassFieldCoreInner extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = (value) => {
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(value);
            }
        };
        this.onButtonClick = (event) => {
            event.preventDefault();
            const nextIsVisible = !this.state.isVisible;
            this.setState({
                isVisible: nextIsVisible,
            });
            if (this.props.onToggle) {
                this.props.onToggle(nextIsVisible);
            }
        };
        this.getButton = () => {
            const { components: { Icon }, labels, toggleButtonLabel, } = this.props;
            return (React.createElement("button", { className: "passfield__button", onClick: this.onButtonClick, type: "button", "aria-pressed": this.state.isVisible ? 'true' : 'false' },
                React.createElement(Icon, { modifiers: this.getButtonIcon(), className: "passfield__button-icon" }),
                React.createElement("span", { className: "sr-only" }, toggleButtonLabel || labels.get('passField.showPassword'))));
        };
        this.state = {
            isVisible: false,
            value: props.defaultValue || '',
        };
    }
    get value() {
        if (this.props.isReadOnly || this.props.isDisabled) {
            return typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
        }
        return this.props.onChange && typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
    }
    BEM() {
        const classArray = ['passfield'];
        if (this.state.isVisible) {
            classArray.push('is-visible');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getInputType() {
        return this.state.isVisible ? 'text' : 'password';
    }
    getButtonIcon() {
        return this.state.isVisible ? '#password-hide' : '#password-show';
    }
    render() {
        const { TextField } = this.props.components;
        return (React.createElement(TextField, Object.assign({}, this.props, { className: this.BEM(), inputClass: "passfield__input", type: this.getInputType(), onChange: this.onChange, value: this.value, contentRenderer: this.getButton })));
    }
}
